angular.module('impactx.login').controller('LoginDialogController', ['$scope',
    'LoginService',
    'AppConfiguration',
    'BrowserSettings',
    'dataGen',
    '$timeout',
    'TranslationService',
    'themeFactory',
    '$window',
    '$mdDialog',
    '$rootScope',
    'ToastService',
    'ixaUserActions',
    LoginDialogController]);

function LoginDialogController($scope, LoginService, AppConfiguration, BrowserSettings, dataGen, $timeout, TranslationService,
                               themeFactory, $window, $mdDialog, $rootScope, ToastService, ixaUserActions) {
    $scope.INDEX = {
        LOGIN: 0,
        PWD_RECOVERY: 1,
        USN_RECOVERY: 2,
        MFA_LOGIN: 3,
    };

    var self = this;
    self.username = "";
    self.passwd = "";
    self.email = "";
    self.mfaCode = "";
    $scope.theme = themeFactory.getTheme();
    $scope.loginAllowed = BrowserSettings.cookiesEnabled;
    $scope.translations = TranslationService;
    $scope.availableLanguages = AppConfiguration.get('availableLanguages');
    $scope.useSelfRegistration = AppConfiguration.get('useSelfRegistration');
    $scope.sentMFA = false;
    $scope.wizardIndex = $scope.INDEX.LOGIN;
    $scope.requestPending = false;

    this.getDialogHeight = function () {
        var elementName = "#login-dialog";
        switch ($scope.wizardIndex) {
            case $scope.INDEX.PWD_RECOVERY:
                elementName = "#pwd-recovery-dialog";
                break;
            case $scope.INDEX.USN_RECOVERY:
                elementName = "#usn-recovery-dialog";
                break;
            case $scope.INDEX.MFA_LOGIN:
                elementName = "#mfa-login-dialog";
                break;
        }
        var element = angular.element(elementName);
        return element.get()[0].offsetHeight; // height + padding.top + padding.bottom
    }

    $scope.changeLanguage = function (language) {
        if($scope.dialogData.password) {
            $scope.dialogData.password.$setValidity("loginError", true);
        }

        if($scope.dialogData.userNamePasswordRecovery) {
            $scope.dialogData.userNamePasswordRecovery.$setValidity("passwordRecoveryError", true);
        }
        if ($scope.dialogData.emailUsernameRecovery) {
            $scope.dialogData.emailUsernameRecovery.$setValidity("usernameRecoveryError", true);
        }
        $rootScope.language = language;
        TranslationService.getInitialTranslations(dataGen, language);
        if (self.customHash) {
            LoginService.getCustomLoginData(self.customHash).then(function(data) {
                if(data && data.loginTranslations) {
                    self.customLoginTranslations = data.loginTranslations;
                }
                else {
                    self.customLoginTranslations = undefined;
                }
                self.customLinks = data.customLinks;
            })
        }
    };

    this.login = function (stayLoggedIn) {
        if ($scope.wizardIndex === $scope.INDEX.MFA_LOGIN) {
            self.loginWithMFA(stayLoggedIn);
        }
        else {
            $scope.loginRequestPending = true;
            if ($scope.wizardIndex === $scope.INDEX.LOGIN) {
                return LoginService.login(self.companyName ? (self.companyName + "$" + self.username) : self.username, self.passwd, stayLoggedIn).then(function () {
                    $scope.loginRequestPending = false;
                }, function (data) {
                    self.authErrors = data.authErrors[0].error;
                    if (self.authErrors) {
                        $scope.dialogData.password.$setValidity("loginError", false);
                    }
                    self.link = data.data.link;
                    self.linkName = data.trns.linkName;
                    if (data.data.sentMFA) {
                        ToastService.openStandardToast(data.authErrors[0].error);
                        $scope.sentMFA = true;
                        $scope.wizardIndex = $scope.INDEX.MFA_LOGIN;
                        var focusWatcher = $scope.$watch(function () {
                            return angular.element('#code_0') && angular.element('#code_0').length;
                        }, function (newValue, oldValue) {
                            if (newValue && newValue > 0) {
                                angular.element('#code_0').focus();
                                focusWatcher();
                            }
                        });
                    }
                    $scope.loginRequestPending = false;
                });
            }
        }
    };

    this.requestPasswordRecovery = function () {
        $scope.requestPending = true;
        dataGen.getData({}, {userLogin: self.companyName ? (self.companyName + "$" + self.username) : self.username,
            customHash: self.customHash}, "/passwordrecovery/request").then(function (data) {
            $timeout(function () {
                $scope.requestPending = false;
                if (!data.timeout) {
                    $scope.timeout = null;
                    $scope.passwordRequestSent = true;
                    $scope.isError = false;
                }
                else if(data.timeout) {
                    $scope.timeout = data.timeout;
                    $scope.isError = true;
                }
            }, 1000);
        });
    };
    
    this.requestUsernameRecovery = function () {
        $scope.requestPending = true;
        dataGen.getData({}, {email: self.email}, "/passwordrecovery/username/request").then(function (data) {
            $timeout(function () {
                $scope.requestPending = false;
                if (!data.timeout) {
                    $scope.timeout = null;
                    $scope.usernameRequestSent = true;
                    $scope.isError = false;
                }
                else if(data.timeout) {
                    $scope.timeout = data.timeout;
                    $scope.isError = true;
                }
            }, 1000);
        });
    }

    this.loginWithMFA = function (stayLoggedIn) {
        $scope.mfaLoginPending = true;
        if ($scope.wizardIndex === $scope.INDEX.MFA_LOGIN) {
            return LoginService.login(self.companyName ? (self.companyName + "$" + self.username) : self.username, self.passwd, stayLoggedIn, self.mfaCode).then(function() {
                $scope.mfaLoginPending = false;
            }, function (data) {
                $scope.sentMFA = false;
                self.authErrors = data.authErrors[0].error;
                self.link = data.data.link;
                self.linkName = data.trns.linkName;
                $scope.mfaLoginPending = false;
            });
        }
    };
    
    this.getRequestMessage = function () {
        if($scope.isError) {
            var message;
            if ($scope.wizardIndex === $scope.INDEX.PWD_RECOVERY) {
                message = TranslationService.get("pwdRecoveryTimeout");
            }
            else if ($scope.wizardIndex === $scope.INDEX.USN_RECOVERY) {
                message = TranslationService.get("usnRecoveryTimeout");
            }
            return message.replace(/\^0/, $scope.timeout);
        }
        else {
            if ($scope.passwordRequestSent && $scope.wizardIndex === $scope.INDEX.PWD_RECOVERY) {
                return TranslationService.get("pwdRecoveryProcessed");
            }
            else if ($scope.usernameRequestSent && $scope.wizardIndex === $scope.INDEX.USN_RECOVERY) {
                return TranslationService.get("usernameResponse");
            }
        }
    };

    this.goTo = function (index) {
        $scope.wizardIndex = index;
    };

    this.logoUrl = AppConfiguration.get('loginPageLogoUrl');
    this.hasActivePasswordRecovery = AppConfiguration.get('hasActivePasswordRecovery');
    this.hasActiveUsernameRecovery = AppConfiguration.get('hasActiveUsernameRecovery');
    this.companyInputOnLogin = AppConfiguration.get('companyInputOnLogin');

    if (self.customLogoURL) {
        this.logoUrl = self.customLogoURL;
    }
    $scope.punchOutUrl = configData.punchOutUrl;
    $scope.punchOutSetupRequest = function () {
        dataGen.postAsFormOtherSystem({}, {
                login: self.username,
                password: self.passwd,
                url: configData.baseUrl + "/jax/ux/cxml/request/",
                language: TranslationService.getCurrentLanguage(),
                testrequest: "ja"
            },
            "/cxml/punchoutsetuprequest/send", $scope.punchOutUrl).then(function (data) {
            $window.location.href = data.data.redirect;
            $mdDialog.hide();
        });
    }

    this.openUserRegistration = function () {
        $mdDialog.hide();
        TranslationService.initializeWithLanguage(dataGen, TranslationService.getCurrentLanguage()).then(function () {
            ixaUserActions.openUserRegistrationDialog(self.clientCompanyId ? self.clientCompanyId : 0,
                self.customLogoURL ? self.customLogoURL : null).then(function (answer) {
                TranslationService.reset(dataGen);
                $mdDialog.show({
                    multiple: true,
                    templateUrl: './modules/login/templates/login.tmpl.html',
                    controller: 'LoginDialogController',
                    controllerAs: "loginCtrl",
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    fullscreen: false,
                    bindToController: true,
                    locals: {
                        customLogoURL: self.customLogoURL,
                        customHash: self.customHash,
                        customLoginTranslations: self.customLoginTranslations,
                        clientCompanyId: self.clientCompanyId
                    },
                    onComplete: function (scope) {
                        scope.dialogData.password.$setValidity("cookiesDisabled", BrowserSettings.cookiesEnabled);
                        scope.isLoaded = true;
                    }
                });
            })
        })
    }

    /*
        Dirty hack to ensure the right flag for Serbia
        The way we retrieve language and country codes needs to be refactored in the future
     */
    $scope.getLanguageFlagCss = function (language) {
        language = language.toLowerCase();
        if (language === 'sr') {
            language = 'rs';
        }
        return 'flag-icon-' + language;
    }
}